@if (overview.fullPageError$ | ngrxPush; as fullPageError) {
  <div>
    <div
      [error]="fullPageError.error"
      (action)="redirect($event, 'button')"
      auraSkeletonLoader
    ></div>
    @if (!fullPageError.error) {
      @if (overview.welcomeTour$ | ngrxPush; as content) {
        @if (!content.disabled) {
          <idp-welcome-tour
            (closeModal)="close()"
            [content]="content"
          ></idp-welcome-tour>
        }
      }
      @let content =
        {
          onboarding: (overview.onboarding$ | ngrxPush) || emptyOnboarding,
          microMoments:
            (overview.microMoments$ | ngrxPush) || emptyMicroMoments,
          header: (overview.header$ | ngrxPush) || '',
          summary: (overview.summary$ | ngrxPush) || emptySummary,
          tracker: (tracker.tracker$ | ngrxPush) || emptyTracker,
          status: (overview.status$ | ngrxPush) || emptyStatus,
          cards: (overview.cards$ | ngrxPush) || emptyCards,
          earnsSummary:
            (overview.earnsSummary$ | ngrxPush) || emptyEarnsSummary,
          skyclubTracker:
            (overview.skyclubTracker$ | ngrxPush) || emptySkyClubTracker,
          amexSkyClubTracker:
            (overview.amexSkyClubTracker$ | ngrxPush) ||
            emptyAmexSkyClubTracker,
          quickLinks: (overview.quickLinks$ | ngrxPush) || emptyQuickLinks,
          benefits: (overview.benefits$ | ngrxPush) || emptyBenefits,
          snapshot: (overview.snapshot$ | ngrxPush) || emptySnapshot,
          upgrades: (overview.upgrades$ | ngrxPush) || emptyUpgrades,
          earns: {
            title: (overview.title$ | ngrxPush) || '',
            banner: (overview.banner$ | ngrxPush) || emptyBanner,
            offers: (overview.offers$ | ngrxPush) || emptyOffers,
            partners: (overview.partners$ | ngrxPush) || false,
            relatedLinks:
              (overview.relatedLinks$ | ngrxPush) || emptyRelatedLinks
          },
          stipulation: (overview.stipulation$ | ngrxPush) || emptyStipulation
        };
      <idp-overview-page
        (openLink)="redirect($event, 'link')"
        (viewBenefitsAction)="setAnalyticsOnModalClick($event)"
        (analyticsEvent)="onAnalyticsEvent($event)"
        (clickAnalyticsEvent)="setAnalyticsOnCardClick($event)"
        (bannerClickEvent)="bannerClickEvent($event)"
        [content]="content"
      ></idp-overview-page>
    }
  </div>
}
